<div class="container-fluid">
  <page-header-breadcrumb
    [pageTitleValue]="pageTitle"
    [pageLinkValue]="'/offers'"
    [currentPageValue]="editMode ? 'Edit Offer' : 'Add Offer'"
  ></page-header-breadcrumb>
  <div class="card mb-4">
    <div class="card-body">
      <form [formGroup]="addOfferForm" (ngSubmit)="onAddOfferSubmit()">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="offer-name">
                Offer Name
              </label>
              <input
                class="form-control"
                id="offer-name"
                formControlName="offerName"
                placeholder="Offer Name"
                type="text"
                name="offer-name"
                required
              />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label class="form-control-label" for="offer-route">
                Choose the Route
              </label>
              <select
                formControlName="offerRoute"
                class="form-control"
                id="offer-route"
                (change)="routeChanged()"
                name="routeId"
                required
              >
                <option *ngFor="let route of routes" [value]="route.id">
                  {{ route.pageName }}
                </option>
              </select>
            </div>
          </div>
          <div class="col" *ngIf="specificRoute">
            <div class="form-group">
              <label class="form-control-label" for="offer-specefic-route">
                Choose the Id of specific Route
              </label>
              <input
                class="form-control"
                id="offer-specefic-name"
                formControlName="offerSpeceficRoute"
                placeholder="specific Route"
                type="text"
                required
                name="route"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label"> Offer Duration </label>
              <input
                formControlName="offerDuration"
                type="text"
                name="duration"
                class="form-control"
                bsDaterangepicker
                [bsConfig]="{
                  isAnimated: true,
                  containerClass: 'theme-blue'
                }"
                name="bsDaterangepicker"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="offer-rank"> Rank </label>
              <select
                formControlName="offerRank"
                class="form-control"
                id="offer-rank"
                name="rank"
              >
                <option
                  *ngFor="let item of ranks; let i = index"
                  [value]="i + 1"
                >
                  {{ i + 1 }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <div
                class="icon-image-placeholder placeholder"
                id="placeholder"
                (click)="onImageUpload($event)"
                accept=".jpg,.png"
                name="img"
              ></div>
              <input
                type="hidden"
                name="fileHidden"
                formControlName="offerFileInput"
              />
              <div
                *ngIf="
                  isSubmited && addOfferForm.controls.offerFileInput.errors
                "
                class="input-errors"
              >
                <p *ngIf="addOfferForm.controls.offerFileInput.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col btns-block">
            <button
              class="btn btn-primary"
              type="submit"
              [disabled]="addOfferForm.invalid"
            >
              {{ editMode ? "Edit" : "Save" }}
            </button>
            <button
              class="btn btn-outline-danger"
              type="button"
              [routerLink]="'/offers'"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<ngx-spinner></ngx-spinner>
